import React, {useState} from "react";
import {Tabs} from "antd";
import MetabaseDashboard from "./MetabaseDashboard";
import {MetabaseReportsContainer} from "./metabaseReports.styles";
import {METABASE_DASHBOARD_TABS} from "../../../constants/constants";

const MetabaseReportsPage = () => {
    const [activeTab, setActiveTab] = useState(METABASE_DASHBOARD_TABS[0].key);

    return (
        <MetabaseReportsContainer>
            <Tabs activeKey={activeTab} onChange={setActiveTab}>
                {METABASE_DASHBOARD_TABS.map(tab => (
                    <Tabs.TabPane tab={tab.title} key={tab.key}>
                        {activeTab === tab.key && <MetabaseDashboard dashboardKey={tab.key} />}
                    </Tabs.TabPane>
                ))}
            </Tabs>
        </MetabaseReportsContainer>
    );
};

export default MetabaseReportsPage;
